exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-box[data-v-2a0d988f] .el-table th{background-color:#f7fbff}\n", ""]);

// exports
